export default "__VITE_ASSET__CxFvfKpq__"